var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.6657V3.33261C2 2.97905 2.14045 2.63997 2.39045 2.38997C2.64046 2.13996 2.97954 1.99951 3.3331 1.99951H4.66619",
    stroke: "currentColor",
    strokeWidth: 1.16643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3311 1.99951H12.6642C13.0177 1.99951 13.3568 2.13996 13.6068 2.38997C13.8568 2.63997 13.9972 2.97905 13.9972 3.33261V4.6657",
    stroke: "currentColor",
    strokeWidth: 1.16643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9972 11.3315V12.6646C13.9972 13.0182 13.8568 13.3573 13.6068 13.6073C13.3568 13.8573 13.0177 13.9977 12.6642 13.9977H11.3311",
    stroke: "currentColor",
    strokeWidth: 1.16643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66619 13.9977H3.3331C2.97954 13.9977 2.64046 13.8573 2.39045 13.6073C2.14045 13.3573 2 13.0182 2 12.6646V11.3315",
    stroke: "currentColor",
    strokeWidth: 1.16643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 7.99854H11.3315",
    stroke: "currentColor",
    strokeWidth: 1.16643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.37fc4b59ff4881c89d4770600e8fd6de.svg";
export { ForwardRef as ReactComponent };